import { FC } from 'react';

import {
  Badge,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from '@mui/material';
import { MessageSquareText } from 'lucide-react';

import { useOfficeChatStore } from '@/store';

interface OfficeChatButtonProps {
  collapsed?: boolean;
}

export const OfficeChatButton: FC<OfficeChatButtonProps> = ({ collapsed }) => {
  const theme = useTheme();
  const { unreadCount, togglePanel, isPanelOpen, hasAccess } =
    useOfficeChatStore();
  const iconColor =
    theme.palette.mode === 'dark'
      ? theme.palette.common.white
      : theme.palette.sideBar.main;

  if (!hasAccess) {
    return null;
  }

  return (
    <ListItemButton
      data-testid="office-chat-button"
      onClick={togglePanel}
      selected={isPanelOpen}
      sx={{
        borderRadius: 2,
        minHeight: 48,
        justifyContent: collapsed ? 'center' : 'initial',
        px: 2.5,
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: 0,
          mr: collapsed ? 0 : 3,
          justifyContent: 'center',
        }}
      >
        <Badge
          badgeContent={unreadCount}
          color="error"
          max={99}
          invisible={unreadCount === 0}
        >
          <MessageSquareText size={24} strokeWidth={1.5} color={iconColor} />
        </Badge>
      </ListItemIcon>
      {!collapsed && (
        <ListItemText
          primary="Office chat"
          primaryTypographyProps={{ fontSize: 15, fontWeight: 500 }}
        />
      )}
    </ListItemButton>
  );
};
